const publicLogin = {
  email: 'front@nutrilogic.com',
  password: '123456',
  remember: true,
  anonymous: true,
};

export default publicLogin;